
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 12a.75.75 0 01-.75-.75v-.75H6A.75.75 0 016 9h.75v-.75a.75.75 0 011.5 0V9H9a.75.75 0 010 1.5h-.75v.75a.75.75 0 01-.75.75zM9 21a.743.743 0 01-.53-.22l-.97-.97-.97.97c-.141.142-.33.22-.53.22s-.389-.078-.53-.22a.752.752 0 010-1.061l.97-.97-.97-.97a.75.75 0 111.06-1.059l.97.97.97-.97c.141-.142.33-.22.53-.22s.389.078.53.22a.752.752 0 010 1.061l-.97.97.97.97A.75.75 0 019 21zM15 10.5A.75.75 0 0115 9h3a.75.75 0 010 1.5h-3zM15 18a.75.75 0 010-1.5h3a.75.75 0 010 1.5h-3zM15 21a.75.75 0 010-1.5h3a.75.75 0 010 1.5h-3z"}}),_c('path',{attrs:{"d":"M4.348 24a2.1 2.1 0 01-2.098-2.095V2.25A2.252 2.252 0 014.5 0h15a2.252 2.252 0 012.25 2.25V21.9a2.084 2.084 0 01-.611 1.482 2.085 2.085 0 01-1.481.618H4.348zm15.308-1.5a.591.591 0 00.42-.176.592.592 0 00.174-.422V15h-7.5v7.5h6.906zM3.75 21.9a.6.6 0 00.597.6h6.903V15h-7.5v6.9zm16.5-8.4V6h-7.5v7.5h7.5zm-9 0V6h-7.5v7.5h7.5zm9-9V2.25a.75.75 0 00-.75-.75h-15a.75.75 0 00-.75.75V4.5h16.5z"}})])
          )
        }
      }
    